/**
 * Program: SDL Common filters
 * Author: SDL
 * Description: SDL Common Filters
 */
import dateFormat from './dateFormat';
import numberFormat from './numberFormat';
import reverse from './reverse';
import nl2br from './nl2br';
import cutString from './cutString';

export default {
  install(Vue) {
    Vue.filter('reverse', reverse);
    Vue.filter('dateFormat', dateFormat);
    Vue.filter('numberFormat', numberFormat);
    Vue.filter('nl2br', nl2br);
    Vue.filter('cutString', cutString);
  },
};



// WEBPACK FOOTER //
// ./src/filters/index.js